import React, { useContext } from "react";
import { VegaFlex, VegaDivider, VegaBox } from "@heartlandone/vega-react";
import AddFeedbackAction from "./AddFeedback";
import CancelActivityAction from "./CancelActivity";
import EditActivityAction from "./EditActivity";
import ViewActivityAction from "./ViewActivity";
import CancelRegistrationAction from "./CancelRegistration";
import ViewRegistrationAction from "./ViewRegistration";
import SendEmailNotificationAction from "./SendEmailNotification";
import { HubContext } from "Redux/Context/context";
import {
  MODULE,
  ACTIVITY_STATUS,
  PUBLISHER_CATEGORY,
  REGISERED_SUB_MENU,
} from "Chore/Constants";
import ViewFeedbackAction from "./ViewFeedback";

function ActivityActions({ activity }) {
  const { myActivitiesState } = useContext(HubContext);
  const { module, subModule } = myActivitiesState;
  const { MY_ACTIVITIES } = MODULE;
  const { STATUS_LABEL } = ACTIVITY_STATUS;
  const { REGISTERED, PUBLISHED } = MY_ACTIVITIES;
  const { publisherCategory, showFeedback, hasFeedback, status, activityStatus } = activity;
  const isViewRegistrationAction = () => {
    return module === PUBLISHED || module === REGISTERED;
  };

  const isCancelRegistration = () => {
    return module === REGISTERED && subModule === REGISERED_SUB_MENU.REGISTERED && 
      isBeforeStartTime() && activityStatus !== STATUS_LABEL.CLOSED;
  };

  const isEditActivityAction = () => {
    return (
      isBeforeStartTime() &&
      status !== STATUS_LABEL.CLOSED &&
      module === PUBLISHED
    );
  };

  const isCancelActivityAction = () => {
    return (
      isBeforeStartTime() &&
      status !== STATUS_LABEL.CLOSED &&
      module === PUBLISHED
    );
  };

  const isAddFeedbackAction = () => {
    return (
      showFeedback && !hasFeedback && module === REGISTERED && subModule === REGISERED_SUB_MENU.PENDING_FEEDBACK
    );
  };

  const isViewActivityAction = () => {
    return module === PUBLISHED || module === REGISTERED;
  };

  const isViewFeedbackAction = () => {
    return showFeedback && hasFeedback && module === REGISTERED && subModule === REGISERED_SUB_MENU.CLOSED;
  };

  const isSendEmailNotificationAction = () => {
    return (
      module === PUBLISHED &&
      publisherCategory !== PUBLISHER_CATEGORY.PERSONAL
    );
  };

  const isBeforeStartTime = () => {
    const currentUTCTime = new Date().getTime();
    const targetUTCTime = new Date(activity.startTime).getTime();
    return targetUTCTime > currentUTCTime;
  }

  return (
    <VegaFlex gap={"size-12"} flexWrap="wrap">
      {[
        isViewRegistrationAction() && (
          <ViewRegistrationAction activity={activity} />
        ),
        isViewActivityAction() && <ViewActivityAction activity={activity} />,
        isCancelRegistration() && (
          <CancelRegistrationAction activity={activity} />
        ),
        isEditActivityAction() && <EditActivityAction activity={activity} />,
        isSendEmailNotificationAction() && (
          <SendEmailNotificationAction activity={activity} />
        ),
        isCancelActivityAction() && (
          <CancelActivityAction activity={activity} />
        ),
        isAddFeedbackAction() && (
          <AddFeedbackAction activity={activity}/>
        ),

        isViewFeedbackAction() && <ViewFeedbackAction activity={activity} />,
      ]
        .filter((button) => !!button)
        .map((button, index) => (
          <React.Fragment key={index}>
            {!!index && (
              <VegaBox height="size-24">
                <VegaDivider direction="vertical" />
              </VegaBox>
            )}
            {button}
          </React.Fragment>
        ))}
    </VegaFlex>
  );
}

export default ActivityActions;
